export { default } from './panel';